<template>
  <div class="container--get-started">
    <FeedbackHeader title="Getting started" pretitle="" />
    <div class="container__inner">
        <div class="question-container">
            <img class="logo--ths-small" src="/images/bahai-logo-small.svg" />
            <div>
              <h4 class="heading-second--pink">
                The Assembly is reaching out to the community to learn more about how people like to receive information from the Assembly and how they like to communicate. <br /><br />
                This short survey will take only a few minutes to complete and will provide the Assembly with invaluable insights. <br /><br />
                Thank you for your assistance.<br />
              </h4>
              <h4 class="heading-second--red">
                If your survey times out, please click the link in the text message again and your survey will reload.
              </h4>
            </div>
        </div>
      <div @click="nextButton()" class="button-bahai button-bahai--link-blue-dk">Next</div>
    </div>
  </div>
</template>

<script>
    import FeedbackHeader from '@/components/FeedbackHeader.vue'

    export default {
        mounted() {
          if (this.isAuthenticated) {
              this.fetchSurveys();
          } else {
              this.$router.push("/sign-in");
          }
        },
        computed: {
          isAuthenticated() {
            return !!this.$store.state.auth.accessToken;
          },
          surveys() {
            return this.$store.state.feedback.surveysList;
          },
          userSurveys() {
            return this.$store.state.feedback.surveyPassings;
          }
        },
        methods: {
          async fetchSurveys() {
            await this.$store.dispatch("getListOfSurveys");
            await this.$store.dispatch("getSurveyPassings");
            let defaultSurvey = this.surveys.filter(s => s.is_active === '1').sort((a, b) => b.id - a.id);
            this.defaultSurvey = defaultSurvey[0];
          },
          setSurvey(id) {
            this.$store.dispatch("setSId", { id: id });
            this.$router.push("/feedback");
          },
          nextButton() {
            if (this.defaultSurvey && this.defaultSurvey.id ) this.setSurvey(this.defaultSurvey.id);
          },
          /* isSurveyComplete(id) { */
          isSurveyComplete() {
            /* let complete = false;
            let filteredSurveys = this.userSurveys.filter(s => s.survey_id === id.toString() && s.is_complete === '1')
            if (filteredSurveys.length > 0)
              complete = true;

            return complete; */
            return false;
          }
        },
        components: {FeedbackHeader},
        data() {
            return {
                title: '',
                processing: false,
                defaultSurvey: undefined
            }
        }
    };
</script>
